import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import NavBar from '../components/navbar/NavBar'
import Authorize from '../router/Authorize'
import Home from './Home'
import ManagePackage from './ManagePackage'
import NotFound from './NotFound'
import SearchMember from './SearchMember'
import SearchUserPackage from './SearchUserPackage'

function DefaultContainer() {
  return (
    <div>
      <NavBar />
      <Routes>
        <Route path="/" element={<Authorize><Home /></Authorize>} />
        <Route path="/manage-package" element={<Authorize><ManagePackage /></Authorize>} />
        <Route path="/search-member" element={<Authorize><SearchMember /></Authorize>} />
        <Route path="/search-user-package" element={<Authorize><SearchUserPackage /></Authorize>} />
        <Route path="*" element={<Navigate to="/"/>} />
      </Routes>
    </div>
  )
}

export default DefaultContainer
